module.exports = __webpack_public_path__ + "static/breedon_card_square-c3df5641a661e9c995685c0beea9c272.jpg";